<!--
  <div
  style="
    display: flex;
    align-items: center;
    justify-content: center;
    height: 80vh;
  "
>
  <div class="spinner-grow text-primary" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
  <div class="spinner-grow text-success" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
  <div class="spinner-grow text-danger" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
  <div class="spinner-grow text-warning" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
  <div class="spinner-grow text-info" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>
-->

<div class="loader-line"></div>
<!--
<div class="loader">
  <div class="loader__element"></div>
</div>
-->
